module.exports = __webpack_public_path__ + "984d85b769681137ccb9afd18288f694.svg";